import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material"
import RefreshButton from "../../../../../common/components/refresh_button"
import AlertError from "../../../../../common/components/alert_error"
import { Header } from "./components/header"
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid"
import { useMemo } from "react"
import DeleteDialog from "../../../../../common/components/delete_dialog"
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar"
import PrimaryButton from "../../../../../common/components/primary_button"
import DynamicIcon from "../../../../../common/components/dynamic_icon"
import { GenerateNovosNegociosColumns } from "./columns"
import { useNovosNegociosViewModel } from "../../viewModels/novos_negocios_lista_view_model"
import { NovosNegociosLista as NovosNegociosListaDao } from "../../../domain/models/novos_negocios_lista"
import { SendMailModal } from "../../../../../common/components/send_email_modal"
import { ReportNovosNegociosModal } from "./components/report_novos_negocios_modal"
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal"


export const NovosNegociosLista = () => {

    const viewModel = useNovosNegociosViewModel();

    const columnsDef = useMemo(() => {
        return GenerateNovosNegociosColumns({
            onActionEdit: viewModel.handleEditNovosNegocios,
            onActionDelete: viewModel.handleNovosNegociosDeleteOpenState,
            onActionExportar: viewModel.handleNovosNegociosExportar,
            onActionEmail: viewModel.handleEmailOpenState,
        });
    }, [
        viewModel.handleEditNovosNegocios,
        viewModel.handleNovosNegociosDeleteOpenState,
        viewModel.handleNovosNegociosExportar,
        viewModel.handleEmailOpenState,
    ]);

    return (
        <>
            <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={
                        <div className="flex flex-row gap-2 ">
                            <div className="w-[220px] ">
                                <PrimaryButton
                                    startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                    color="info"
                                    onClick={() => viewModel.handleOpenReportNovosNegociosModal(true)}>
                                    Relatório
                                </PrimaryButton>
                            </div>
                            <div className="w-[220px] ">
                                <PrimaryButton
                                    startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                    onClick={() => viewModel.handleNewNovosNegocios()}>
                                    Novo Negócio
                                </PrimaryButton>
                            </div>
                        </div>
                    }
                />
            </PageTopBar>

            <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
                <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
                    <Link underline="hover" color="inherit">
                        Home
                    </Link>
                    <Typography className="text-primary-green">
                        Novos Negócios
                    </Typography>
                </Breadcrumbs>
                <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
                    <div className="flex gap-2 items-center w-full">
                        <h1 className="text-3xl font-medium text-black dark:text-white"> Novos Negócios</h1>
                        <p>Pesquisar </p>
                        <RefreshButton onClick={viewModel.handleReload} />
                    </div>


                </div>


                {
                    viewModel.errorMessage !== undefined ? (
                        <div className="w-full">
                            <AlertError
                                messageErro={viewModel.errorMessage}
                                onTryAgain={viewModel.handleReload} />
                        </div>
                    ) : (
                        <>
                            <Header
                                ddlCliente={viewModel.ddlCliente}
                                selectedIdsCliente={viewModel.filters.idsCliente ?? []}
                                cidade={viewModel.filters.cidade}
                                status={viewModel.filters.status}
                                data={viewModel.filters.data}
                                handleStatusChange={viewModel.handleStatusChange}
                                handleDataChange={viewModel.handleDataChange}
                                onClearFilters={viewModel.handleClearFilters}
                                handleIdsClienteChange={viewModel.handleIdsClienteChange}
                                handleCidadeChange={viewModel.handleCidadeChange}
                            />


                            <Stack spacing={0}>
                                <div className="w-full flex flex-row justify-between items-stretch">
                                    <div className="flex flex-col justify-between flex-1">
                                        <TablePagination
                                            component="div"
                                            count={viewModel.pagination.totalItems}
                                            page={viewModel.pagination.page - 1}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                            rowsPerPage={viewModel.pagination.rowsPerPage}
                                            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
                                    </div>
                                </div>

                                <StyledDataGrid
                                    tableName="NovosNegocios_Lista"
                                    disableColumnMenu={false}
                                    showToolbar={true}
                                    disableRowSelectionOnClick={true}
                                    getRowId={(row: NovosNegociosListaDao) => row.idNovosNegocios}
                                    columns={columnsDef}
                                    loading={viewModel.loading}
                                    checkboxSelection={false}
                                    rows={viewModel.novosNegociosLista}
                                    rowCount={viewModel.novosNegociosLista.length}
                                    pageSizeOptions={[10, 25, 50, 100]}
                                    paginationMode="server"
                                    paginationModel={{
                                        page: viewModel.pagination.page,
                                        pageSize: viewModel.pagination.rowsPerPage,
                                    }}
                                    pinnedColumns={{
                                        right: ['exportar', 'email', 'idNovosNegocios'],
                                    }}
                                />

                                <TablePagination
                                    component="div"
                                    count={viewModel.pagination.totalItems}
                                    page={viewModel.pagination.page - 1}
                                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                    rowsPerPage={viewModel.pagination.rowsPerPage > 0 ? viewModel.pagination.rowsPerPage : 25}
                                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                                />
                            </Stack>


                        </>
                    )
                }

            </div >

            <DeleteDialog
                open={viewModel.openDeleteModal}
                onClose={() => viewModel.handleNovosNegociosDeleteOpenState(null, false)}
                title={`Você realmente deseja excluir este item?`}
                onDelete={viewModel.handleConfirmarDeletarNovosNegocios}
            />

            <SendMailModal
                open={viewModel.openEmailModal}
                loading={viewModel.loading}
                sendTo={viewModel.emailSendTo}
                subject={viewModel.emailSubject}
                attachment={viewModel.emailAttachment}
                body={viewModel.emailBody}
                onClose={() => viewModel.handleEmailOpenState(null, false)}
                onSubmit={viewModel.handleEmailSubmit}
            />

            <ReportNovosNegociosModal
                open={viewModel.openReportNovosNegociosModal}
                loading={viewModel.loading}
                saving={viewModel.saving}
                ddlCentroCusto={viewModel.ddlCentroCusto}
                onClose={viewModel.handleOpenReportNovosNegociosModal}
                onSubmit={viewModel.handleReportNovosNegociosListaSubmit}
            />

            <ReportViewerModal
                reportViewerState={viewModel.reportViewerState}
            />

        </>
    )
}

